import { render, staticRenderFns } from "./version-comparer.vue?vue&type=template&id=4f78ce99"
import script from "./version-comparer.ts?vue&type=script&lang=ts&external"
export * from "./version-comparer.ts?vue&type=script&lang=ts&external"
import style0 from "./version-comparer.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports